import { div } from '../../scripts/dom-builder.js';
import moveInstrumentation from '../../scripts/utils/editor-support-utils.js';

export default async function decorate(block) {
  const promos = block.querySelectorAll('div.promo-list > div');
  const promoItems = div({ class: 'promo-items' });
  if (promos.length === 3) {
    promoItems.classList.add('three-item');
  }
  promos.forEach((promo) => {
    const promoItem = div({ class: 'promo' }, '');
    promoItem.classList.add('vertical');

    const classes = promo.querySelector(':scope > div:nth-of-type(1)');
    if (classes) {
      const styles = classes.textContent.split(', ');
      styles.forEach((style) => {
        promoItem.classList.add(style);
      });
    }
    const logo = promo.querySelector(':scope > div:nth-of-type(2) ');
    const promoEyebrow = promo.querySelector(
      ':scope > div:nth-of-type(3) > h4',
    );
    const promoTitle = promo.querySelector(':scope > div:nth-of-type(3) > h2');
    const promoText = promo.querySelectorAll(
      ':scope > div:nth-of-type(3) > *:not(:last-child):not(h2):not(h4)',
    );
    const promoLink = promo.querySelector(
      ':scope > div:nth-of-type(3) > *:last-child',
    );
    if (logo) {
      const imgIcon = logo.querySelector('img');
      if (imgIcon) {
        imgIcon.ariaHidden = true;
      }
      promoItem.append(logo);
    }
    const promoTitles = div();
    if (promoEyebrow) {
      promoTitles.append(promoEyebrow);
    }
    if (promoTitle) {
      promoTitles.append(promoTitle);
    }
    if (promoTitle || promoEyebrow) {
      promoItem.append(promoTitles);
    }
    if (promoText) {
      promoText.forEach((text) => {
        promoItem.append(text);
      });
    }
    if (promoLink) {
      promoItem.append(promoLink);
    }
    moveInstrumentation(promo, promoItem);
    promoItems.append(promoItem);
    promo.remove();
  });
  block.append(promoItems);
}
